//设置mac码
export const setMac = "/equipment/device/not_token/set_mac";
//根据mac获取设备信息
export const getMacInfo = "/equipment/device/not_token/get_info";
//检测上传图片
export const upimg = "/report/check/not_token/img";
//获取问诊问题
export const question = "/report/check/not_token/question";
//提交生成报告(无token)
export const setReport = "/report/check/not_token/submit";
//提交生成报告(有token)
export const setsetReportToken = "/report/check/submit";
//获取报告详情(无token)
export const getReport = "/report/check/not_token/get_report";
//获取报告详情（有token）
export const getReportToken = "/report/check/get_report";
//添加设备登录的uuid
export const popupDevice = "/not_token/bin/user-device";
//轮询获取token
export const userDevice = "/not_token/bin/user-device-info";
//发送报告的消息模版
export const sendTemplate = "/report/check/send_template";
//将用户和设备报告绑定
export const bindUserid = "/report/check/bind_user";
//根据token获取用户信息
export const userInfo = "/user-info";
//获取上一次检测的信息
export const lastInfo = "/report/check/last_info";
//根据服务类型获取相关信息
export const getServer = "/report/check/get_server";
//同上，无token
export const getServerNoToken = "/report/check/not_token/get_server";

/**
 * 开方报告
 */
//检测提交
export const submit = `/prescribe/submit`;
//根据父问题id获取他的所有子问题
export const question_add = `/prescribe/question/list`;
//同上，无token
export const question_add_notoken = `/prescribe/question/not_token/list`;
//获取报告详情
export const report_info = `/prescribe/info`;
//意见反馈
export const feedback = `/prescribe/feedback`;
//新增证候（报告无证候时调用）
export const add_sick = `/prescribe/add_sick`;
//查看问诊结果
export const report_node = `/prescribe/node`;
//获取设备模块列表
export const get_modules = `/report/check/get_modules`;
//添加用户
export const user_add = `/user`;
//获取账户医生和业务员状态
export const user_info = `/account-special-info`;
//上传名字和性别
export const be_doctor = `/account/apply-doctor`

//微信分享
export const config = `/wx/jsconfig`;
//上传到oss
export const osspolicy = `/report/oss`;
//客户列表
export const company_list = `/customer`;
//更新基础信息
export const user_change = `/user`;
//上传医生证书
export const add_zhengshu = `/doctor-material/account`;
//开方报告列表
export const prescribe_list  = `/prescribe/report/list`;
//统计，折线图饼状图
export const census_list  = `/report/healthtrend/get`;
//养生报告列表
export const report_list = `/report/list`;
//手机号或姓名登录
export const account_tel = `/not_token/create_account_by_tel`
//获取省市区
export const address = `/regions`;
//微信端预约列表
export const mylist = `/admin/subscribe/mylist`;
//取消预约
export const recordCancel = `/admin/subscribe/cancel`;
//新增预约
export const addRecor = `/admin/subscribe/add`;
//最近一次预约记录
export const last_info = `/admin/subscribe/last_info`;
//单条详情
export const subscribe_info = `/admin/subscribe/info`;
//评价列表
export const assess_list = `/admin/set_meal/pingjia_operate_list`;
//去评价
export const assess_add = `/admin/set_meal/pingjia`;
//机构列表
export const organizations = `/admin/subscribe/organization`;
//套餐列表
export const user_meal = `/admin/set_meal/user_set_meal`;
//我的总佣金
export const service_commission_user = `/admin/service_commission/user`;
//佣金结算-明细列表
export const detaile_list = `/admin/service_commission/detaile_list`;
//我的会员卡
export const my_list = `/admin/card/my_list`;
//预约时间段
export const time_slot = `/admin/subscribe/time_list`;
//教授之家活动报告
export const diaoyan = `/diaoyan/add`;
//打印
export const dayin = `/report/check/not_token/dayin`;